/* eslint-disable no-empty */
import { SelectOptionGroup } from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const eventHelpoutsApi = createApi({
  reducerPath: 'eventHelpoutsApi',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchPossibleHelpoutables: builder.query<SelectOptionGroup[], void>({
      query: (request) => 'helpouts/possible-helpoutables',
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useLazyFetchPossibleHelpoutablesQuery,
  reducerPath,
  reducer,
  middleware,
} = eventHelpoutsApi;
